import { Vector } from "./Vector.js";
import { Point2D } from "./Point2D.js";
class Point3D extends Point2D {
  constructor(x, y, z) {
    if (x instanceof Vector) {
      super(x.x, x.y);
      this.z = x.z;
    } else if (typeof x === "object") {
      super({ x: x.x ?? 0, y: x.y ?? 0 });
      this.z = x.z ?? 0;
    } else {
      super(x, y);
      this.z = z ?? 0;
    }
  }
  copy() {
    return new Point3D(this.x, this.y, this.z);
  }
}
export {
  Point3D
};
//# sourceMappingURL=Point3D.js.map
